<template>
  <div>
    <StatusBanner>
      <template slot="header">
        {{headerText}}.
      </template>
      <template slot="subhead">
        
      </template>
      <template slot="actions">
        Although it won't show up in searches, its data will still show up in reports. If that was a mistake, you can <button @click="cleanse" class="text-blue-400 underline">un-archive it</button>.
      </template>
    </StatusBanner>
  </div>
</template>

<script>
import _get         from 'lodash-es/get'
import parse        from 'date-fns/parse'
import isToday      from 'date-fns/is_today'
import isYesterday  from 'date-fns/is_yesterday'

import StatusBanner from '@/components/StatusBanner.vue'

export default {
  components: {
    StatusBanner
  },

  props: {
    archivingTeacher: {type: Object},
    archivedAt: {type: String},
    cleanse: {
      type: Function,
      default: () => { console.warn('Cardstock - ArchivedBanner: unhandled cleanse function')}
    },
    trash: {
      type: Function,
      default: () => { console.warn('Cardstock - ArchivedBanner: unhandled trash function')}
    },
    objectName: {
      type: String,
      required: true
    }
  },

  computed: {
    headerText() {
      if (_get(this.archivingTeacher, 'isCurrent') == true) {
        return 'You archived this ' + this.objectName + ' ' + this.formattedDateStamp
      } else if (_get(this.archivingTeacher, 'last') != null ) {
        return this.archivingTeacher.last + ' archived this number ' + this.formattedDateStamp
      } else {
        return 'This ' + this.objectName + ' was archived ' + this.formattedDateStamp
      }
    },

    formattedDateStamp() {
      if (isToday(this.archivedAt)) {
        return "today"
      } else if (isYesterday(this.archivedAt)) {
        return "yesterday"
      } else {
        return 'on ' + parse(this.archivedAt).toLocaleString('en-US', {month: 'short', day: 'numeric', year: 'numeric'})
      }
    },
  }
}
</script>
